import styled from '../../../styles/styledComponents/themeComponents';

export const PreviewGridGapStyle = styled.div<{ col: number; rowGap?: number; colGap?: number }>`
  display: grid;
  grid-template-columns: ${({ col, colGap }) =>
    `repeat(${col},calc(${100 / col}% - ${((colGap || 0) * (col - 1)) / col}px))`};
  row-gap: ${({ rowGap }) => rowGap + 'px'};
  column-gap: ${({ colGap }) => colGap + 'px'};
`;
